export const PRICE_TYPE_LIST_HEADING_ID = 'tn-syos-price-type-list-heading';


/**
 * @param {string} headingText
 */
export default function render(headingText) {
  return `<h2 id="${PRICE_TYPE_LIST_HEADING_ID}" class="tn-syos-seat-info__price-type-heading">${headingText}</h2>`;
}
